import { useAuth } from "../../contexts/AuthContext";
import styles from "./OnboardingLogout.module.css";

// Logout para el onboarding (no hay sidebar). Muestra el email logueado por contexto.
export default function OnboardingLogout({ className = "" }) {
  const { auth, logout } = useAuth();
  const email = auth?.user?.email;

  return (
    <div className={`${styles.container} ${className}`}>
      {email && <span className={styles.email}>{email}</span>}
      <button type="button" className={styles.button} onClick={logout}>
        Cerrar sesión
      </button>
    </div>
  );
}
